module.exports = __webpack_public_path__ + "img/premium-managment-services.e647c335.jpg";